module.exports = __webpack_public_path__ + "img/img3.a9c70240.png";